import { Box, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import { StudentsTableColumnRenderArgs } from '../types';

export type SessionsCellProps = StudentsTableColumnRenderArgs<'sessions'>;

export const SessionsCell: React.VFC<SessionsCellProps> = ({ value }) => {
  const { classes } = useSessionsCellStyles();
  const numberOfSessions = value;
  const noSessions = value === 0;

  return (
    <Box width="100%">
      <Typography
        variant="body2"
        className={noSessions ? classes.disabledColor : classes.sessionNumber}
        data-testid="students-table-number-of-sessions"
      >
        {numberOfSessions}
      </Typography>
    </Box>
  );
};

const useSessionsCellStyles = makeStyles({ name: 'SessionsCell' })((theme) => ({
  sessionNumber: {
    letterSpacing: '0.4px',
    fontWeight: 400,
  },
  disabledColor: {
    color: theme.palette.text.disabled,
  },
}));
